/* Enhances the Leslie Shopify Forms country picker without changing submission data. */
(() => {
  'use strict';
  if (!window.HTMLDialogElement || !Intl.DisplayNames) return;
  const en = new Intl.DisplayNames(['en'], { type: 'region' });
  const zh = new Intl.DisplayNames(['zh-Hant'], { type: 'region' });
  const preferred = ['HK', 'CN', 'MO', 'TW'];
  const overrides = { HK: ['香港', 'Hong Kong'], CN: ['中國內地', 'China'], MO: ['澳門', 'Macao'], TW: ['台灣', 'Taiwan'] };
  const bound = new WeakSet();
  let active = null;
  const dialog = document.createElement('dialog');
  dialog.className = 'ushop-country-dialog';
  dialog.setAttribute('aria-labelledby', 'ushop-country-title');
  dialog.innerHTML = `<header><h2 id="ushop-country-title">選擇國家／地區 <span>Country / region</span></h2><button type="button" data-close aria-label="關閉 Close">×</button></header><div class="uc-search"><label for="ushop-country-search">搜尋名稱或區碼 / Search name or code</label><input id="ushop-country-search" type="search" placeholder="香港 / Hong Kong / 852" autocomplete="off"><p role="status" aria-live="polite" data-status></p></div><nav aria-label="首字母索引 Alphabet index"></nav><div class="uc-results"></div>`;
  document.body.append(dialog);
  const input = dialog.querySelector('input');
  const results = dialog.querySelector('.uc-results');
  const nav = dialog.querySelector('nav');
  const status = dialog.querySelector('[data-status]');
  const normalize = value => value.normalize('NFKD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/[\s+()\-]/g, '');
  function closeNative() {
    if (active?.trigger.isConnected && active.trigger.getAttribute('aria-expanded') === 'true') active.trigger.click();
  }
  function finish() {
    closeNative();
    dialog.close();
  }
  dialog.querySelector('[data-close]').addEventListener('click', finish);
  dialog.addEventListener('cancel', event => { event.preventDefault(); finish(); });
  dialog.addEventListener('click', event => { if (event.target === dialog) { const b = dialog.getBoundingClientRect(); if (event.clientX < b.left || event.clientX > b.right || event.clientY < b.top || event.clientY > b.bottom) finish(); } });
  dialog.addEventListener('close', () => { active?.nativeStyle.remove(); document.documentElement.style.overflow = active?.overflow ?? ''; const trigger = active?.trigger; active = null; trigger?.focus({ preventScroll: true }); });
  function fitViewport() {
    const viewport = window.visualViewport;
    const width = viewport?.width || innerWidth, height = viewport?.height || innerHeight;
    const mobile = width <= 600, tablet = !mobile && (width <= 1024 || (width <= 1366 && matchMedia("(pointer: coarse)").matches)), gap = mobile ? 0 : tablet ? 24 : 16;
    const boxWidth = Math.min(760, width - gap * 2), boxHeight = Math.min(mobile ? height : 760, height - gap * 2);
    Object.assign(dialog.style, { position: 'fixed', margin: '0', right: 'auto', bottom: 'auto', transform: 'none',
      width: `${boxWidth}px`, height: `${boxHeight}px`, maxHeight: `${boxHeight}px`,
      left: `${(viewport?.offsetLeft || 0) + (width - boxWidth) / 2}px`, top: `${(viewport?.offsetTop || 0) + (tablet ? Math.min(24, Math.max(0, height - boxHeight)) : (height - boxHeight) / 2)}px` });
  }
  window.addEventListener('resize', () => { if (dialog.open) fitViewport(); });
  window.visualViewport?.addEventListener('resize', () => { if (dialog.open) fitViewport(); });
  window.visualViewport?.addEventListener('scroll', () => { if (dialog.open) fitViewport(); });
  function render() {
    if (!active) return;
    const query = normalize(input.value);
    const matches = active.items.filter(item => normalize(`${item.chinese} ${item.original} ${item.english} ${item.code} ${item.dial}`).includes(query));
    results.replaceChildren(); nav.replaceChildren();
    status.textContent = matches.length ? `${matches.length} 個國家／地區 · countries / regions` : '找不到結果，請嘗試名稱或區碼。No matching results.';
    const groups = new Map();
    if (!query) groups.set('常用地區 / Frequently used', preferred.map(code => matches.find(item => item.code === code)).filter(Boolean));
    for (const item of matches) { const initial = normalize(item.english)[0]?.toUpperCase(); const letter = /^[A-Z]$/.test(initial) ? initial : '#'; if (!groups.has(letter)) groups.set(letter, []); groups.get(letter).push(item); }
    let index = 0;
    for (const [label, items] of groups) {
      if (!items.length) continue;
      const section = document.createElement('section'); section.id = `uc-group-${index++}`;
      const heading = document.createElement('h3'); heading.textContent = label; section.append(heading);
      const grid = document.createElement('div'); grid.className = 'uc-grid'; section.append(grid);
      for (const item of items) {
        const button = document.createElement('button'); button.type = 'button'; button.className = 'uc-option';
        button.setAttribute('aria-label', `${item.chinese} ${item.english} ${item.dial}`);
        if (item.selected) { button.classList.add('is-selected'); button.setAttribute('aria-current', 'true'); }
        const names = document.createElement('span'); const chinese = document.createElement('strong'); chinese.textContent = item.chinese; const english = document.createElement('small'); english.textContent = item.english; names.append(chinese, english);
        const dial = document.createElement('span'); dial.className = 'uc-dial'; dial.textContent = item.dial; button.append(names, dial);
        button.addEventListener('click', () => {
          const original = active?.root.getElementById(`select-country-${item.code}`);
          if (!original) { status.textContent = '表單已更新，請關閉後重新選擇。Please reopen the selector.'; return; }
          original.click(); dialog.close();
        }); grid.append(button);
      }
      results.append(section);
      const jump = document.createElement('button'); jump.type = 'button'; jump.textContent = label.length === 1 ? label : '常用'; jump.setAttribute('aria-label', label); jump.addEventListener('click', () => { results.scrollTop += section.getBoundingClientRect().top - results.getBoundingClientRect().top; }); nav.append(jump);
    }
    results.scrollTop = 0;
  }
  input.addEventListener('input', render);
  function open(root, trigger) {
    if (dialog.open || trigger.getAttribute('aria-expanded') !== 'true') return;
    const options = [...root.querySelectorAll('[id^="select-country-"][role="option"]')];
    if (!options.length) return; // Keep the native picker usable if Forms changes its markup.
    const items = options.map(option => {
      const code = option.id.replace('select-country-', ''); const original = option.textContent.trim(); const dial = original.match(/\+\d+\s*$/)?.[0].trim();
      let english, chinese;
      try { english = en.of(code); chinese = zh.of(code); } catch { return null; }
      if (!dial || !english) return null;
      [chinese, english] = overrides[code] || [chinese, english];
      return { code, original, dial, chinese, english, selected: option.getAttribute('aria-selected') === 'true' };
    }).filter(Boolean).sort((a, b) => a.english.localeCompare(b.english, 'en'));
    if (items.length !== options.length) return;
    const nativeStyle = document.createElement('style');
    nativeStyle.textContent = '#country-selector-dropdown{visibility:hidden!important;pointer-events:none!important}';
    active = { root, trigger, items, nativeStyle, overflow: document.documentElement.style.overflow };
    root.append(nativeStyle);
    input.value = ''; render(); fitViewport(); dialog.showModal(); document.documentElement.style.overflow = 'hidden'; fitViewport();
    // Avoid opening the software keyboard before a mobile user chooses to search.
    dialog.querySelector('[data-close]').focus({ preventScroll: true });
  }
  function connect() {
    document.querySelectorAll('shopify-forms-embed').forEach(host => {
      const root = host.shadowRoot; if (!root || bound.has(root)) return; bound.add(root);
      let requestedTrigger = null;
      function openRequested() {
        if (!requestedTrigger || dialog.open) return;
        const trigger = requestedTrigger;
        open(root, trigger);
        if (dialog.open) requestedTrigger = null;
      }
      root.addEventListener('click', event => {
        const trigger = event.target.closest?.('button[aria-label^="Country code"]');
        // Internal clicks close the native list; only a real user gesture opens our dialog.
        if (!event.isTrusted || !trigger || dialog.open) return;
        requestedTrigger = trigger;
        requestAnimationFrame(openRequested);
      });
      // Handles the option list appearing asynchronously after the original click.
      new MutationObserver(openRequested).observe(root, { childList: true, subtree: true });
    });
  }
  connect();
  const discovery = new MutationObserver(connect); discovery.observe(document.body, { childList: true, subtree: true });
  let attempts = 0; const timer = setInterval(() => { connect(); if (++attempts >= 60) clearInterval(timer); }, 1000);
})();
